import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { ChevronRight } from "lucide-react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bentornato!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2.5 mb-10 group w-fit" data-testid="login-back-home">
          <img
            src="/reelio-icon-transparent.png"
            alt=""
            className="h-9 w-auto"
          />
          <span className="font-display font-black text-2xl tracking-tighter text-white">
            Reelio
          </span>
        </Link>

        <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#FF4400] mb-3">
          · Accesso
        </div>
        <h1 className="font-display font-black text-4xl tracking-tighter mb-2">Bentornato.</h1>
        <p className="text-zinc-400 font-body mb-10">Continua a creare reel che convertono.</p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-2">Email</label>
            <input
              type="email"
              required
              data-testid="login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@brand.com"
              className="w-full px-4 py-3 bg-zinc-900 border border-zinc-800 text-white placeholder-zinc-600 focus:outline-none focus:ring-1 focus:ring-[#FF4400] focus:border-[#FF4400] rounded-sm font-body"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-2">Password</label>
            <input
              type="password"
              required
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full px-4 py-3 bg-zinc-900 border border-zinc-800 text-white placeholder-zinc-600 focus:outline-none focus:ring-1 focus:ring-[#FF4400] focus:border-[#FF4400] rounded-sm font-body"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#FF4400] hover:bg-[#FF6633] disabled:opacity-50 text-white font-display font-bold rounded-sm transition-colors"
          >
            {loading ? "Accesso in corso..." : "Accedi"}
            {!loading && <ChevronRight className="w-4 h-4" />}
          </button>
        </form>

        <p className="mt-8 text-sm text-zinc-500 font-body">
          Non hai un account?{" "}
          <Link to="/register" data-testid="login-link-register" className="text-[#FF4400] hover:text-[#FF6633] font-bold">
            Registrati
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
